'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'gem';
var width = 512;
var height = 512;
var aliases = [128142];
var unicode = 'f3a5';
var svgPathData = 'M289 445l-33 35-33-35-223-237 112-176 288 0 112 176-223 237zM431 224L81 224 256 410 431 224zm3.7-48L385 97.9 311.5 176 434.7 176zM336 80l-160 0 80 85 80-85zM127 97.9L77.3 176 200.5 176 127 97.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGem = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;